import React from 'react'
import { RouteProps } from 'react-router-dom'

import ClosedTemplate from '../../../templates/Closed'
import { useClosedTemplateProps } from '../../../templates/Closed/useProps'

const ClosedPage: React.FC<RouteProps> = () => {
  const templateProps = useClosedTemplateProps()

  return <ClosedTemplate {...templateProps} />
}

export default ClosedPage
